export default function () {
  //Todo: Implement something like this: https://medium.com/@claudiaconceic/infinite-plain-javascript-slider-click-and-touch-events-540c8bd174f2

}
